module.exports = __webpack_public_path__ + "img/CtrlRoom_sun_2.4e7db16d.png";